export default __webpack_public_path__ + "static/media/Aura-Egg__75.9ff608a6.png";